export const size = {
  mobileS: 330,
  mobileM: 400,
  mobileL: 500,
  tablet: 800,
  laptopS: 900,
  laptopM: 1100,
  laptop: 1200,
  laptopL: 1300,
  laptopXL: 1600,
  desktop: 1800,
  desktopL: 2500,
};

export const device = {
  mobileS: `(min-width: ${size.mobileS}px)`,
  mobileM: `(min-width: ${size.mobileM}px)`,
  mobileL: `(min-width: ${size.mobileL}px)`,
  tablet: `(min-width: ${size.tablet}px)`,
  laptopS: `(min-width: ${size.laptopS}px)`,
  laptop: `(min-width: ${size.laptop}px)`,
  laptopL: `(min-width: ${size.laptopL}px)`,
  laptopXL: `(min-width: ${size.laptopXL}px)`,
  desktop: `(min-width: ${size.desktop}px)`,
  desktopL: `(min-width: ${size.desktopL}px)`,
  iphoneX: `only screen and (device-width : 375px) and (device-height : 812px) and (-webkit-device-pixel-ratio : 3)`,
  retinaDesktop: `
    only screen and (-webkit-min-device-pixel-ratio: 2) and (min-width: ${size.tablet}px),
    only screen and (min--moz-device-pixel-ratio: 2) and (min-width: ${size.tablet}px),
    only screen and (-o-min-device-pixel-ratio: 2/1) and (min-width: ${size.tablet}px),
    only screen and (min-device-pixel-ratio: 2) and (min-width: ${size.tablet}px),
    only screen and (min-resolution: 192dpi) and (min-width: ${size.tablet}px),
    only screen and (min-resolution: 2dppx) and (min-width: ${size.tablet}px)`,
  retina: `
    only screen and (-webkit-min-device-pixel-ratio: 2),
    only screen and (min--moz-device-pixel-ratio: 2),
    only screen and (-o-min-device-pixel-ratio: 2/1),
    only screen and (min-device-pixel-ratio: 2),
    only screen and (min-resolution: 192dpi),
    only screen and (min-resolution: 2dppx)`,
};

export const typography = {
  super: '100px',
  hero: '64px',
  heroMobile: '40px',
  h1: '48px',
  h1Small: '40px',
  h2Bigger: '32px',
  h2: '24px',
  h2Small: '20px',
  h3: '16px',
  h4: '14px',
  span: '12px',
  small: '10px',
  sectionTitle: '18px',
};

export const general = {
  columnWidth: 49, // this is in px
  gutterWidth: 5, // this is in px
};

export const zIndices = {
  modal: 9999,
  dialogs: 9998,
  header: 999,
  underHeader: 998,
  top: 99,
  over: 1,
  normal: 0,
  under: -1,
};

export const getWidth = (cols: number) =>
  `${cols * general.columnWidth + (cols - 1) * general.gutterWidth}px`;

export const isMobile = () => document.body.clientWidth <= size.tablet;
export const isTablet = () =>
  document.body.clientWidth >= size.tablet &&
  document.body.clientWidth < size.laptopS;
export const isSmallScreen = () =>
  document.body.clientWidth > size.tablet &&
  document.body.clientWidth <= size.laptopXL;
export const isLaptop = () => document.body.clientWidth <= size.laptopL;
export const isBigScreen = () => document.body.clientWidth >= size.desktopL;
